//ModalsAddAssets
import React, { useState } from "react";
import { Col, Modal, Row, Spin } from "antd";
import AssetsSection from "../subs/AssetsSection";


function ModalsAddAssets({ open, onClose, guarantors, datas }) {
    const [loading, setLoading] = useState(false)
    const [provinces, setProvinces] = useState([]);
    const [guarantorsed, setGuarantorsed] = useState(guarantors);

    // load edit data
    const handleLoadEdit = (data, type) => {
        setGuarantorsed(prev =>
            prev.map(g =>
                g.assetId === data
                    ? { ...g, investigation: type } // อัปเดตค่าที่ตรงกัน
                    : g
            )
        );
    }

    const handleClose = () => {
        onClose(false);
    };

    return (
        <Modal
            open={open}
            onCancel={handleClose}
            width={1200}
            footer={null}
            title={
                <div style={{ textAlign: "center", width: "100%" }}>
                    ผู้เกี่ยวข้องกับสัญญา {datas?.contno}
                </div>
            }
        >
            {loading ? <>
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <Spin size="large" tip="กำลังโหลด..." />
                </div>
            </> :
                <Row justify={'center'}>
                    <Col span={24}>
                        <AssetsSection
                            people={guarantorsed}
                            handleLoadEdit={handleLoadEdit}
                            provinces={provinces}
                            datas={datas}
                        />
                    </Col>
                </Row>
            }
        </Modal>
    );
}

export default ModalsAddAssets;

